<template>
  <div class="page__container">
    <BreadCrumbsTemplate/>
    <ContactsTemplate />
  </div>
</template>

<script>
import ContactsTemplate from '@/components/ContactsTemplate.vue';
import BreadCrumbsTemplate from '@/components/BreadCrumbsTemplate.vue';

export default {
  name: 'ContactsView',
  components: {
    ContactsTemplate,
    BreadCrumbsTemplate
  }
};
</script>
